import React from 'react';
import { FormattedMessage } from 'react-intl';
import userRoles from '../../../constants/userRoles';
import { ReactComponent as CustomersIcon } from '../../../assets/icons/menu-customers.svg';
import { ReactComponent as OverviewIcon } from '../../../assets/icons/menu-overview.svg';
import { ReactComponent as ContractIcon } from '../../../assets/icons/menu-transactions.svg';
import { ReactComponent as TransactionsIcon } from '../../../assets/icons/menu-contract.svg';
import { ReactComponent as UsersIcon } from '../../../assets/icons/menu-users.svg';
import { ReactComponent as GraphIcon } from '../../../assets/icons/menu-graph.svg';

const iconStyle = { width: 20, height: 20, flexShrink: 0 };

const links = {
  mainCustomers: {
    path: '/',
    label: <FormattedMessage id={'app.menu.customers.label'} />,
    exact: true,
    icon: <CustomersIcon style={iconStyle} />,
    action: () => sessionStorage.removeItem('customersFilter'),
  },
  mainTransactions: {
    path: '/',
    label: <FormattedMessage id={'app.menu.transactions.label'} />,
    exact: true,
    icon: <TransactionsIcon style={iconStyle} />,
    action: () => null,
  },
  billingprices: {
    path: '/billingprices',
    label: <FormattedMessage id={'app.menu.invoicePrices.label'} />,
    exact: true,
    icon: <TransactionsIcon style={iconStyle} />,
    action: () => null,
  },
  transactions: {
    path: '/transactions',
    label: <FormattedMessage id={'app.menu.transactions.label'} />,
    exact: false,
    icon: <TransactionsIcon style={iconStyle} />,
    action: () => sessionStorage.removeItem('transactionsFilter'),
  },
  contracts: {
    path: '/contracts',
    label: <FormattedMessage id={'app.menu.contracts.label'} />,
    exact: false,
    icon: <ContractIcon style={iconStyle} />,
    action: () => sessionStorage.removeItem('contractsFilter'),
  },
  users: {
    path: '/users',
    label: <FormattedMessage id={'app.menu.users.label'} />,
    exact: false,
    icon: <UsersIcon style={iconStyle} />,
    action: () => sessionStorage.removeItem('usersFilter'),
  },
  priceDevelopment: {
    path: '/productPricesGraph',
    label: <FormattedMessage id={'app.priceDevelopment.label'} />,
    exact: false,
    icon: <GraphIcon style={iconStyle} />,
    action: () => null,
  },
};

const mainMenuLinks = {};
mainMenuLinks[userRoles.ADMIN] = [links.mainCustomers, links.billingprices, links.transactions, links.contracts, links.users, links.priceDevelopment];

mainMenuLinks[userRoles.ADMIN_VIEWER] = [links.mainCustomers, links.billingprices, links.transactions, links.contracts, links.users, links.priceDevelopment];

mainMenuLinks[userRoles.TRADER] = [links.mainTransactions, links.contracts, links.users, links.priceDevelopment];

mainMenuLinks[userRoles.KAM] = [links.mainCustomers, links.transactions, links.contracts, links.priceDevelopment];

mainMenuLinks[userRoles.ASM] = [links.mainCustomers, links.transactions, links.contracts, links.priceDevelopment];

mainMenuLinks[userRoles.CUSTOMER] = [
  { path: '/', label: <FormattedMessage id={'app.menu.overview.label'} />, exact: true, icon: <OverviewIcon style={iconStyle} />, action: () => null },
  links.contracts,
  { path: '/pricealert', label: <FormattedMessage id={'app.menu.pricealert.label'} />, exact: false, action: () => null },
  links.priceDevelopment,
];

mainMenuLinks[userRoles.CUSTOMER_VIEWER] = [
  { path: '/', label: <FormattedMessage id={'app.menu.overview.label'} />, exact: true, icon: <OverviewIcon style={iconStyle} />, action: () => null },
  links.contracts,
  { path: '/pricealert', label: <FormattedMessage id={'app.menu.pricealert.label'} />, exact: false, action: () => null },
  links.priceDevelopment,
];

export default mainMenuLinks;
